
import * as ArticleTypes from 'Flow2/components/Article/ArticleTypes/ArticleTypes';
import DateHelper from 'Flow2/components/Article/Helpers/DateTimeHelper';
import SortHelper from 'Flow2/components/Article/Helpers/SortHelper';
import SearchHelper from 'Flow2/components/Article/Helpers/SearchHelper';
import store from 'index';

class LogsHelper {

    searchActions = ({ data, currentSearch }) => {
        if (data && data.length && currentSearch) {
            return data.filter(item => item.actionDisplayData.toLowerCase().includes(currentSearch.toLowerCase()));
        }
        return data;
    }

    filterByActionDate = ({ data, dateFormat, property }) => {
        let given = property ? property : 'date';
        return data.filter(item => DateHelper.dateFormat(item[given], dateFormat) === DateHelper.dateNow(dateFormat));
    }

    filterByPastDays = ({ data, dateFormat, pastdays, property }) => {
        let given = property ? property : 'date';
        return data.filter(item => {
            let today = DateHelper.dateNow(dateFormat);
            let actionDay = DateHelper.dateFormat(item[given], dateFormat);
            let filterDay = Date.now() + -pastdays * 24 * 3600 * 1000;
            let filterDayFormat = DateHelper.dateFormat(filterDay, dateFormat);
            if (actionDay <= today && actionDay >= filterDayFormat) return true;
            return false;
        });
    }

    filterLastestItems = ({ data, field, sorted = ArticleTypes.DESC }) => {
        let sortedData = SortHelper.sortByValue({ data, sorted, field });
        return sortedData.filter((item, index) => index < ArticleTypes.LATESTMAX);
    }

    filterActions = ({ data, currentFilter, property = null }) => {
        if (data && data.length && currentFilter) {
            switch (currentFilter) {
                case ArticleTypes.LATESTITEMS:
                    return this.filterLastestItems({ data, field: property });
                case ArticleTypes.TODAY:
                    return this.filterByActionDate({ data, dateFormat: ArticleTypes.FILTER_FORMAT, property });
                case ArticleTypes.SEVENDAYS:
                    return this.filterByPastDays({ data, dateFormat: ArticleTypes.FILTER_FORMAT, pastdays: 7, property });
                case ArticleTypes.THISMONTH:
                    return this.filterByActionDate({ data, dateFormat: ArticleTypes.FILTER_MM, property });
                case ArticleTypes.THISYEAR:
                    return this.filterByActionDate({ data, dateFormat: ArticleTypes.FILTER_YYYY, property });
            }
        }
        return data;
    }

    verifyLogs = (logsData) => {
        if (logsData && logsData.logs) {
            let logs = logsData.logs;
            if (logs.charAt(0) === ',') {
                logs = logs.substring(1, logs.length);
            }
            if (logs.charAt(logs.length - 1) === ',') {
                logs = logs.substring(0, logs.length - 1);
            }
            if (logs.includes("}{")) {
                let regex = /}{/ig;
                logs = logs.replace(regex, '},{');
            }
            logs = "[" + logs + "]";
            try {
                return JSON.parse(logs);
            } catch (error) {
                //  console.log("LAMTEST LOG DATA ERROR!");
            }
        }
        return [];
    }

    getMaxResults = (articleObjects) => {
        if (articleObjects.articleLogs.currentData) {
            return articleObjects.articleLogs.currentData.length;
        }
        return '0';
    }

    getLogsData = ({ logsData, users, formatMessage }) => {
        if (logsData && logsData.logs && users && formatMessage) {
            let data = this.verifyLogs(logsData);
            if (data && data.length) {
                return data.map(item => {
                    let displayData = '';
                    ArticleTypes.LOG_FIELDS.forEach(el => {
                        if (el.name === ArticleTypes.USER) {
                            displayData = SearchHelper.getUser({ users, item, el });
                        }
                        else if (el.name === ArticleTypes.ACTION) displayData = formatMessage(`data.article.log.${item[el.name]}`);
                        else if (el.type && el.type === ArticleTypes.DATETYPE) displayData = DateHelper.dateFormat(item[el.name], 'dd.MM.yyyy HH:mm:ss');
                        else displayData = item[el.name];
                        item[`${el.name}DisplayData`] = displayData;
                    })
                    return { ...item }
                })
            }
        }
        return [];
    }

    updateLogsData = ({ action, user, isFirst = false, created, owner }) => {
        let entry = { action, user, date: DateHelper.dateNow('yyyy-MM-dd HH:mm:ss') };
        if (isFirst) {
            if (created && owner) {
                let createAction = { action: ArticleTypes.CREATE, date: created, user: owner };
                return JSON.stringify(createAction) + "," + JSON.stringify(entry);
            }
            return JSON.stringify(entry);
        }
        return "," + JSON.stringify(entry);
    }

    handleLogActions = ({ action, updateArticleMetadata, id, metadata = {} }) => {
        const { currentDisplay } = store.getState().article.articleObjects;
        let articleId = id ? id : currentDisplay;
        if (articleId) {
            let logs = this.updateLogsData({
                action, user: store.getState().auth.user.id,
                isFirst: false
            });
            if (metadata) metadata.logs = logs;

            updateArticleMetadata({ id: articleId, metadata, logsLoading: true });
        }
    }

    setEditLogsAction = ({ id, updateArticleMetadata, metadata }) => {
        this.handleLogActions({ action: ArticleTypes.EDIT, id, updateArticleMetadata, metadata });
    }

    getLogsObj = ({ action, id, isFirst = false }) => {
        const { currentDisplay } = store.getState().article.articleObjects;
        let articleId = id ? id : currentDisplay;
        if (articleId) {
            let logs = this.updateLogsData({ action, user: store.getState().auth.user.id, isFirst });
            return { logs, articleId };
        }
    }
}

export default LogsHelper = new LogsHelper();